var DEFAULT_CREATOR_THEME = {
    colors: {
        color1: "",
        color2: "",
        color3: "",
        color4: "",
        color5: "",
    },
    font: {
        slug: "",
        title: "",
        url: "",
    },
};

export { DEFAULT_CREATOR_THEME };
//# sourceMappingURL=Theme.constants.js.map
